import { Platform, NativeModules } from 'react-native';

export const platform = {
  version: 4.0,
  behavior: 'padding',
};
